import { render, staticRenderFns } from "./PersonaEdit.vue?vue&type=template&id=0c30f1dc&scoped=true&"
import script from "./PersonaEdit.vue?vue&type=script&lang=js&"
export * from "./PersonaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c30f1dc",
  null
  
)

export default component.exports